import { render, staticRenderFns } from "./WorkspaceHeader.vue?vue&type=template&id=29585208&scoped=true&"
import script from "./WorkspaceHeader.vue?vue&type=script&lang=js&"
export * from "./WorkspaceHeader.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceHeader.vue?vue&type=style&index=0&id=29585208&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29585208",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29585208')) {
      api.createRecord('29585208', component.options)
    } else {
      api.reload('29585208', component.options)
    }
    module.hot.accept("./WorkspaceHeader.vue?vue&type=template&id=29585208&scoped=true&", function () {
      api.rerender('29585208', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/workspace/WorkspaceHeader.vue"
export default component.exports